import { CSSObject } from '@chakra-ui/react';
import {
  TAccordionButton,
  TAccordionItem,
  TAccordionPanel,
} from './MarketsByMatch.styles';

export const AccordionItem = ({ isNested }: TAccordionItem): CSSObject => ({
  borderRadius: 'md',
  contain: 'paint',
  boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.25)',
  mb: '3',
  border: '0',

  ...(isNested && {
    boxShadow: 'unset',
    mb: '2',
  }),
});

export const AccordionPanel = ({ isNested }: TAccordionPanel): CSSObject => ({
  border: 0,
  p: '3',
  borderBottomRadius: 'md',
  bg: 'white',

  ...(isNested && {
    border: '1px',
    borderTop: 0,
    borderColor: 'blackAlpha.200',
    boxShadow:
      '0px 3px 8px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset;',
  }),
});

export const AccordionButton = ({ isNested }: TAccordionButton): CSSObject => ({
  bg: 'linear-gradient(180deg, var(--bc-colors-alpha-500) 0%, var(--bc-colors-alpha-700) 100%)',
  h: '32px',
  color: 'white',

  borderRadius: 'md',
  fontWeight: 'bold',
  fontSize: 'xs',
  p: '2',
  border: '1px',
  borderColor: 'transparent',
  borderBottom: '0',

  svg: {
    border: '1px',
    borderColor: 'transparent',
    color: 'white',
    borderRadius: '100%',
    boxSize: '20px',
  },

  _hover: {
    bg: 'linear-gradient(180deg, var(--bc-colors-alpha-600) 0%, var(--bc-colors-alpha-800) 100%)',
  },

  ...(isNested && {
    '&&&': {
      bg: 'linear-gradient(180deg, var(--bc-colors-alpha-500) 0%, var(--bc-colors-alpha-700) 100%)',
      border: '1px',
      borderColor: 'blackAlpha.200',
      color: 'white',

      svg: {
        borderColor: 'transparent',
        color: 'white',
      },

      _expanded: {
        color: 'white',
        borderBottomRadius: 0,
        borderBottom: 0,
      },
    },
  }),

  _expanded: {
    borderBottomRadius: 'none',
    bg: 'linear-gradient(180deg, var(--bc-colors-alpha-500) 0%, var(--bc-colors-alpha-700) 100%)',
    color: 'white',
    borderColor: 'transparent',
    borderBottomColor: '#4B5A6D',

    _hover: {
      bg: 'linear-gradient(180deg, var(--bc-colors-alpha-600) 0%, var(--bc-colors-alpha-800) 100%)',
    },

    ...(isNested && {
      bg: 'gamma.200',
      color: 'white',
      borderBottomColor: 'transparent',

      _hover: {
        bg: 'gamma.300',
      },
    }),
  },
});

export const BoxWrapper: CSSObject = {
  py: '2',
  px: '0',
  borderBottomRadius: '6px',
};
